export var FallbackSrcDirective = [
    function () {
        return {
            link: function ($scope, $element, _$attributes) {
                var $attributes = _$attributes;
                $element.on('error', function (event) {
                    event.target.setAttribute('src', $attributes.fallbackSrc);
                    event.target.classList.add('fallback-src');
                });
                $scope.$on('$destroy', function () {
                    $element.off('error');
                });
            },
            restrict: 'A',
        };
    },
];
